import axios from 'axios';

const API_BASE = '/api/packing-slips';

export const packingSlipService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getNextNumber: async () => {
    const response = await axios.get(`${API_BASE}/next-number`);
    return response.data;
  },

  /** Resolves packing slip notification emails (same rules as create). Optional customer_id from the work order / slip. */
  getNotificationRecipientsPreview: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/notification-recipients-preview`, { params });
    return response.data;
  },

  /** Packing slip invoice/shipment notification email history (includes deleted slips). */
  getNotificationLogs: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/notification-logs`, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  markShipped: async (id, shipped_date = null) => {
    const response = await axios.post(`${API_BASE}/${id}/mark-shipped`, { shipped_date });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
